export default "__VITE_ASSET__0c31f8e2__"